module.exports = __webpack_public_path__ + "img/logo.a0c88234.png";